var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"help flex-column"},[_c('div',{staticClass:"title-container flex-row"},[_c('div',{staticClass:"flex-column"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('help')))])])]),_c('HelpComponent')],1)}
var staticRenderFns = []

export { render, staticRenderFns }